export const NAV = [
  { id: "coaches", label: "Coaches" },
  { id: "programme", label: "Programme" },
  { id: "venue", label: "Venue" },
  { id: "pricing", label: "Pricing" },
  { id: "faq", label: "FAQ" },
];

export const HERO_FACTS = [
  { k: "Dates", v: "12–20 Dec 2026" },
  { k: "Duration", v: "9 days" },
  { k: "Location", v: "Adelaide, SA" },
  { k: "Coaching", v: "UEFA A Licensed" },
  { k: "Eligibility", v: "Born 2011–2016" },
  { k: "Investment", v: "$549 AUD inc. GST" },
  { k: "Per day", v: "$61 per day" },
];

export const PILLARS = [
  { n: "01", t: "Technical Ability", d: "First touch, ball manipulation, striking and passing quality refined through high-repetition, game-relevant practice." },
  { n: "02", t: "Tactical Awareness", d: "Understanding space, shape and the principles of play — in and out of possession." },
  { n: "03", t: "Decision-Making", d: "Scanning, recognising cues and choosing the right action at match speed, under pressure." },
  { n: "04", t: "Confidence", d: "A demanding but supportive environment where players learn to express themselves on the ball." },
];

export const INCLUDED = [
  { t: "Elite coaching", d: "Elite coaching daily across all nine days, led by UEFA A licensed coaches.", big: true },
  { t: "Camp T-shirt", d: "Professional Elite Performance Lab camp T-shirt." },
  { t: "Photography & video", d: "Professional photography and videos from the programme." },
  { t: "Player feedback", d: "Individual player feedback on strengths and development priorities." },
];

export const BRING = "Players must bring their own water bottle and wear black shorts and black socks.";

export const COACHES = [
  {
    name: "Danny Bailey",
    role: "Head Coach",
    initials: "DB",
    photo: "/images/danny.jpg",
    photoPos: "62% 45%",
    licence: "UEFA A Licensed",
    points: [
      "Former Head of Academy Development, Chelsea FC (2008–2015)",
      "Former Head of Academy Development, Tottenham Hotspur (Spurs) (2015–2018)",
      "Founder, Bailey Football Academy",
      "Director of Football, Heritage College",
      "Experience developing players for professional football",
    ],
  },
  {
    name: "Georgios Economou",
    role: "Co-Coach & Founder",
    initials: "GE",
    photo: "/images/george.jpg",
    licence: "UEFA A Licensed (2026)",
    points: [
      "First Team Coach, Adelaide Cobras",
      "Technical specialist in youth development",
      "Former professional footballer in Bulgaria, Romania, England and Cyprus",
    ],
  },
];

export const FAQS = [
  { q: "Will my child train from 8:00am to 2:00pm every day?", a: "No. 8:00am–2:00pm is the venue operating window. Each age group has its own allocated session time within that window, so your child attends only their group's session each day." },
  { q: "When will we receive our exact session time?", a: "Exact session times will be emailed by 25 November 2026, or earlier once confirmed." },
  { q: "How is my child's group decided?", a: "Groups are allocated automatically during registration based on your child's birth year and gender — not their age on the first day of camp. You'll see the allocated group before payment." },
  { q: "Can I register more than one child?", a: "Yes. You can add siblings in a single registration without re-entering parent details. Each player is $549 AUD including GST (Stripe transaction fee already deducted), and each child is counted as a separate place." },
  { q: "What should my child bring?", a: "Players must bring their own water bottle and wear black shorts and black socks. The professional Elite Performance Lab camp T-shirt is provided." },
  { q: "Is there a waitlist?", a: "No. Registration closes on 25 November 2026 or as soon as the programme is full, whichever comes first." },
  { q: "What is the refund policy?", a: "Cancellations before 25 November 2026 receive a 50% refund. After the cutoff on 25 November 2026, registrations are non-refundable. Full terms will be published on our Terms page." },
  { q: "Is Elite Performance Lab endorsed by UEFA?", a: "No. Elite Performance Lab is independent and is not endorsed, operated or sponsored by UEFA. Our coaches hold UEFA A licences as personal coaching qualifications." },
];

export const VENUE = {
  name: "PropAint 'n Panel Oval",
  address: "Birdwood Terrace, North Plympton SA 5037",
  mapEmbed: "https://www.google.com/maps?q=Birdwood+Terrace,+North+Plympton+SA+5037&output=embed",
  directions: "https://www.google.com/maps/dir/?api=1&destination=Birdwood+Terrace,+North+Plympton+SA+5037",
};
